





















import { Prop, Component, Vue, Watch } from "vue-property-decorator";

@Component({})
export default class SearchBox extends Vue {
  @Prop({ default: false }) private readonly enableClearFilter!: boolean;
  private emitFilterClear(evt: any) {
    this.$emit("clearFilter", true);
  }
}
